import { Box, Stack } from "@mui/material";
import {
  PrimaryFormUserName,
  SecondaryFormDateOfBirth,
} from "react-common-ui-library";
import { StyledButton } from "react-common-ui-library/FPACT/Buttons";
import { useIntl } from "react-intl";
import {
  CONTAINED,
  SPACING_8__10,
  SUBMIT,
} from "../../../Constants/CommonConstants";
import {
  FORGOT_PASSWORD_CONTINUE_BUTTON,
  FORGOT_PASSWORD_NEED_HELP_CONTENT,
  FORGOT_PASSWORD_NEED_HELP_TITLE,
} from "../../../Constants/ForgotPasswordConstants";
import {
  StyledFormInputsBox,
  StyledSmallerFieldWrapperBox,
} from "../../../Styles/Common/CommonStyles";
import { GetPasswordButtonWrapper } from "../../../Styles/Login/ForgotPassword/ForgotPasswordStyles";
import ForgotPasswordInfoAlert from "./ForgotPasswordInfoAlert";

/**
 * @description Forgot Password form elements that can be imported in ForgotPassword component.
 * @returns {ReactNode} Render the username and Month and day of birth inputs with continue button.
 */
const ForgotPasswordFormElements = () => {
  const intl = useIntl();

  return (
    <Stack spacing={7}>
      <Stack spacing={4}>
        <StyledFormInputsBox>
          <PrimaryFormUserName />
        </StyledFormInputsBox>
        <StyledSmallerFieldWrapperBox>
          <SecondaryFormDateOfBirth />
        </StyledSmallerFieldWrapperBox>
      </Stack>
      <Stack spacing={SPACING_8__10}>
        <ForgotPasswordInfoAlert
          contentId={FORGOT_PASSWORD_NEED_HELP_CONTENT}
          title={FORGOT_PASSWORD_NEED_HELP_TITLE}
        />
        <GetPasswordButtonWrapper>
          <Box>
            <StyledButton
              variant={CONTAINED}
              fullWidth
              id={FORGOT_PASSWORD_CONTINUE_BUTTON}
              type={SUBMIT}
            >
              {intl.formatMessage({
                id: FORGOT_PASSWORD_CONTINUE_BUTTON,
              })}
            </StyledButton>
          </Box>
        </GetPasswordButtonWrapper>
      </Stack>
    </Stack>
  );
};

export default ForgotPasswordFormElements;
